import { g as getRoomType } from './get-room-type.js';
import { t as translateDate } from './translate-date.js';
import './index2.js';

/**
 * **Todo Alojamiento**
 *
 * @exports bs_327
 * @category engines
 */
function factory({ window, document, thn }) {

  const engine = {};

  /**
     * @memberOf module:bs_327
     * @see {@link prestart}
     *
     * @param {object} ctx - The context object.
     */
  engine.boot = function boot() {

    const container = document.querySelector('#tabla-productos-completa');

    if (container) {

      thn.todoAlojamientoPageCheck = thn.debounce(thn.pageCheck, 500);

      thn.observeDom(container, thn.todoAlojamientoPageCheck, {
        childList: true,
        subtree: true,
        attributes: true,
      });

      thn.shutdown(function () {
        thn.todoAlojamientoPageCheck.cancel();
        thn.stopObserveDom(container, thn.todoAlojamientoPageCheck);
        delete thn.todoAlojamientoPageCheck;
      });
    }

  };

  /**
     * @memberOf module:bs_327
     * @see {@link language_check}
     *
     * @param {object} ctx - The context object.
     */
  engine.languageCheck = function languageCheck(ctx) {
    return new Promise(function (resolve, reject) {
      let lang;
      if (window.location.hostname.match(/(todoalojamiento|hoteltermaldolores|costacarilo)\./)) {
        lang = window.location.pathname.match(/(\w{2}-\w{2}\/?)/)[0];
        if (lang && ctx.langs.test(lang)) {
          resolve(lang);
          return;
        }
        resolve('es');
        return;
      }

      lang = window.location.pathname.match(ctx.urlRe);
      lang = lang && lang.length && lang[1];
      if (lang && ctx.langs.test(lang)) {
        resolve(lang);
        return;
      }
      reject('no_language');
    });
  };
  /**
    *
    * @memberOf module:bs_327
    *
    */
  function roomDetailsParseData(numNights) {
    const roomElArray = [...document.querySelectorAll('.booking-item')];

    if (thn.empty(roomElArray)) {
      return {};
    }

    const roomsInfo = roomElArray
      .map((room) => {
        const roomName = document.querySelector('.booking-item-title.fs17.mt-7')?.innerText?.toLowerCase();
        const roomType = getRoomType(roomName);
        const roomAdults = [...room.querySelectorAll('.pull-left.fs13 > div > p:nth-child(2) .icono-personas-hab')].length;
        const roomRates = [...room.querySelectorAll('table > tbody > tr:nth-child(6), table > tbody > tr:nth-child(12)')]
          .map((rate) => {
            const rateName = rate.querySelector('span.fuente-rem-can-hab')?.dataset?.originalTitle?.trim();
            const price = thn.parseNumber(rate.querySelector('.textPrecioSM')?.textContent);
            const breakfastSelector = rate.querySelector('.fontcolor-4BBA7D')?.textContent;
            const breakfastRegex = /Desayuno|Breakfast|café/;
            const hasBreakfast = (breakfastSelector && !!breakfastSelector.match(breakfastRegex));
            const refundableRegex = /Flexible|flexível/;
            const isRefundable = (rateName && !!rateName.match(refundableRegex));
            const infoRate = {
              id: '',
              name: rateName,
              totalNight: price / numNights,
              breakfast: hasBreakfast,
              refundable: isRefundable,
            };

            return infoRate;
          });

        return {
          id: '',
          name: roomName,
          adults: roomAdults || 2,
          children: 0,
          type: roomType,
          prices: roomRates,
        };

      }).filter(Boolean);

    return roomsInfo;

  }
  /**
     * @memberOf module:bs_327
     * @this thn.widgets.price
     * @see {@link Price#observe_dom}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceObserveDom = function priceObserveDom(ctx) {

    const container = document.querySelector('.modal.fade');

    if (container && !thn.todoAlojamientoPriceObserver) {

      thn.todoAlojamientoPriceObserver = thn.debounce(function () {
        if (!thn.isVisible(container)) {
          ctx.widget.refresh();
        }
      }, 2000);

      thn.observeDom(container, thn.todoAlojamientoPriceObserver, {
        childList: false,
        subtree: false,
        attributes: true,
      });

      thn.pageUnload(() => {
        thn.todoAlojamientoPriceObserver.cancel();
        thn.stopObserveDom(container, thn.todoAlojamientoPriceObserver);
        delete thn.todoAlojamientoPriceObserver;
      });
    }

  };

  /**
     * @memberOf module:bs_327
     * @this thn.widgets.price
     * @see {@link Price#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceParseData = function priceParseData(ctx) {
    const widgetData = {};

    // Dates
    const dateBegin = ((document.querySelector('#formBuscadorFechaDesde') || {}).value);
    const dateEnd = ((document.querySelector('#formBuscadorFechaHasta') || {}).value);

    if (dateBegin && dateEnd) {
      widgetData.dateBegin = translateDate(dateBegin, thn.data.language || 'en');
      widgetData.dateEnd = translateDate(dateEnd, thn.data.language || 'en');
      widgetData.nights = thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
    }

    // Occupancy
    const adults = ((document.querySelector('#formBuscador div[name=adultos] label.active') || {}).textContent || 2);
    const children = ((document.querySelector('#formBuscador div[name=ninios] label.active') || {}).textContent || 0);

    widgetData.adults = thn.parseNumber(adults);
    widgetData.children = thn.parseNumber(children);
    widgetData.guests = widgetData.adults + widgetData.children;

    // Currency
    const currency = ((document.querySelector('#main-header .nav-drop:nth-child(2)') || {}).textContent);

    // Prices and Rooms
    const rooms = [...document.querySelectorAll('.booking-list .booking-item')].map((el) => {
      const price = thn.parseNumber(((el.querySelector('.textPrecioSM') || {}).textContent || false));
      let occupancy = el.querySelectorAll('.vista-capacidad-hab .icono-personas-hab').length;
      occupancy = (occupancy === 0) ? thn.parseNumber((el.querySelector('.booking-item-features>li:nth-child(1)>span') || {}).textContent) : occupancy;

      return {
        price: price,
        occupancy: occupancy,
      };
    }).filter((room) => room.price && room.occupancy && (room.occupancy >= widgetData.guests));
    rooms.sort((a, b) => a.price - b.price);

    if (!thn.empty(rooms) && currency && widgetData.nights) {
      widgetData.price = thn.parseNumber(rooms[0].price) / widgetData.nights;
      widgetData.currency = thn.parseCurrency(currency);
      widgetData.roomDetails = roomDetailsParseData(widgetData.nights);
      widgetData.set = true;
    } else if (thn.empty(rooms)) {
      widgetData.noRooms = true;
    }

    return widgetData;
  };

  /**
     * @memberOf module:bs_327
     * @this thn.widgets.booking
     * @see {@link Booking#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.bookingParseData = function bookingParseData(ctx) {

    const widgetData = {};

    const dates = ((document.querySelector('.order-payment-list small') || {}).textContent || '').split('->');

    if (dates.length > 1) {
      widgetData.dateBegin = translateDate(dates[0], thn.data.language || 'en');
      widgetData.dateEnd = translateDate(dates[1], thn.data.language || 'en');
    }

    const price = ((document.querySelector('.order-payment-list .text-right') || {}).textContent);
    const bookingId = ((document.querySelector('.order-payment-list b') || {}).textContent);
    if (price && bookingId) {
      widgetData.price = thn.parseNumber(price);
      widgetData.currency = thn.parseCurrency(price);
      widgetData.bookingId = thn.parseNumber(bookingId);
    }
    return widgetData;

  };

  return engine;

}

export { factory };
